// extracted by mini-css-extract-plugin
module.exports = {"container":"Body_container__3qyKt","contentWrapper":"Body_contentWrapper__V1N4e","sensorsWrapper":"Body_sensorsWrapper__2NO1I"};